import React, { useCallback, useEffect, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import DCCostBatchDetail from "./DCCostBatchDetail";
import { getBlockedSkuStatusRows, getFlaggedSkuStatusRows } from "../../API/dcSkuStatusApi";

const DCBlockedItems = () => {
  const [detailRows, setDetailRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const isMountedRef = useRef(true);

  const loadRows = useCallback(async () => {
    setLoading(true);

    try {
      const [blockedItems, flaggedItems] = await Promise.all([
        getBlockedSkuStatusRows(),
        getFlaggedSkuStatusRows(),
      ]);

      if (!isMountedRef.current) {
        return;
      }

      const blockedItemsRows = blockedItems.map((row, index) => ({
        ...row,
        id: row.id || row.detailId || row.parsedSku || `blocked-item-${index}`,
        status: row.status || "Paused",
      }));
      const flaggedItemsRows = flaggedItems.map((row, index) => ({
        ...row,
        id: row.id || row.detailId || row.parsedSku || `flagged-item-${index}`,
        status: row.status || "Flagged",
      }));

      setDetailRows([...blockedItemsRows, ...flaggedItemsRows]);
    } catch {
      if (isMountedRef.current) {
        setDetailRows([]);
      }
    } finally {
      if (isMountedRef.current) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    isMountedRef.current = true;
    void loadRows();

    return () => {
      isMountedRef.current = false;
    };
  }, [loadRows]);

  return (
    <>
      <div style={{ marginBottom: 12 }}>
        <h1 style={{ margin: 0 }}>Paused Items / Flagged Items</h1>
        <p style={{ margin: "4px 0 0", color: "#4b5563" }}>
          Track items that need attention before DC cost changes move forward.
        </p>
      </div>
      {loading ? (
        <Box sx={{ color: "#4b5563", fontSize: 14, mb: 1 }}>
          <Typography variant="body2" component="span">
            Loading paused items data...
          </Typography>
        </Box>
      ) : null}
      <DCCostBatchDetail
        batchIdOverride="145-DC"
        exportFileNameOverride="paused flagged items export.xlsx"
        frozenColumnsOverride={[
          { field: "parsedSku", headerName: "parsedSku", width: 120 },
          { field: "batchId", headerName: "batchId", width: 110 },
          { field: "hqLine", headerName: "hqLine", width: 90 },
        ]}
        detailRowsOverride={detailRows}
        onRestoreSuccess={loadRows}
        hideHeader
        hideDescription
        hideBulkActions
        hideRowActions
        showExportButton
        titleOverride="Paused Items / Flagged Items"
        noteOverride="Review the paused and flagged items below."
      />
    </>
  );
};

export default DCBlockedItems;
